import React, { useMemo } from 'react';

import { FormattedMessage } from 'react-intl';

import { useGetYouthAwardsQuery } from '@modules/youthProfile/api';
import YouthAdvancementsCard from '@shared/components/YouthAdvancementsCard';
import type { YouthAdvancementItem } from '@shared/components/YouthAdvancementsCard/types';
import { advancementTypes } from '@shared/constants';

interface YouthAwardsProps {
  /** Scoutbook user id from the route */
  userId?: string;
}

/** The youth's awards. View More is off for now; only ranks have a details page */
export default function YouthAwards(props: YouthAwardsProps) {
  const { userId } = props;

  const { data, isFetching } = useGetYouthAwardsQuery(
    // Same args the youthProfile module uses, so both read one cache entry
    { userId: userId as string, params: { status: 'all' } },
    { skip: !userId },
  );

  const items = useMemo<YouthAdvancementItem[]>(
    () =>
      (data ?? []).map(award => ({
        ...award,
        id: award.userAwardId ?? award.awardId,
        imageUrl: award.imageUrl100,
        advancementType: advancementTypes.AWARDS,
        award,
      })),
    [data],
  );

  return (
    <YouthAdvancementsCard
      title={<FormattedMessage id="shared.AdvancementType.awards.plural" />}
      items={items}
      loading={isFetching}
    />
  );
}
